var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'תוקף',"error-message":_vm.expiration.error,"focused":_vm.focused,"empty":_vm.expiration.isEmpty}})}
var staticRenderFns = []

export { render, staticRenderFns }